module.exports = __webpack_public_path__ + "media/src/components/EmployerProfile/img/glassdoorIcon-895d8a8d9783f60517fe62316d1642ed.svg";